import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { RemoteActionId, RemoteButtonId } from "./remoteMap.js";

/** The viewer's own choices. A button or press type missing here keeps its default. */
export type RemoteOverrides = Partial<Record<RemoteButtonId, { press?: RemoteActionId; longPress?: RemoteActionId }>>;

interface RemoteMapState {
  overrides: RemoteOverrides;
  choose: (button: RemoteButtonId, kind: "press" | "longPress", action: RemoteActionId) => void;
  /** One press type of one button back to its default. */
  clear: (button: RemoteButtonId, kind: "press" | "longPress") => void;
  resetAll: () => void;
}

export const useRemoteMap = create<RemoteMapState>()(
  persist(
    (set) => ({
      overrides: {},
      choose: (button, kind, action) =>
        set((state) => ({ overrides: { ...state.overrides, [button]: { ...state.overrides[button], [kind]: action } } })),
      clear: (button, kind) =>
        set((state) => {
          const rest = { ...state.overrides[button] };
          delete rest[kind];
          const next = { ...state.overrides };
          if (rest.press || rest.longPress) next[button] = rest;
          else delete next[button];
          return { overrides: next };
        }),
      resetAll: () => set({ overrides: {} }),
    }),
    { name: "slq.remoteMap", version: 1 },
  ),
);
